import { render, staticRenderFns } from "./CreateUpdate.vue?vue&type=template&id=77a89c16&scoped=true"
import script from "./CreateUpdate.vue?vue&type=script&lang=js"
export * from "./CreateUpdate.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdate.vue?vue&type=style&index=0&id=77a89c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a89c16",
  null
  
)

export default component.exports